import { ValueFormatterParams } from "ag-grid-community";

export const percentage =
  (options: Intl.NumberFormatOptions = {}, useDecimal: boolean = false) =>
  (params: ValueFormatterParams): string => {
    const numberValue = useDecimal
      ? Number(params.value)
      : Number(params.value) / 100;

    if (isNaN(numberValue)) return "";
    const { currency, minimumFractionDigits, maximumFractionDigits, ...rest } =
      options;
    return new Intl.NumberFormat("en-US", {
      style: "percent",
      currency,
      minimumFractionDigits,
      maximumFractionDigits,
      ...rest,
    }).format(numberValue);
  };
